<template>
    <div class="loader-line-mask animate-spin">
        <div class="loader-line"></div>
    </div>
</template>
